import { API } from "shared/constants/AppEnums"

export const getListDocNotulensi = async (page, filter, general) => {
    try {
        let published = filter === 'publish' ? true : false
        const response = await fetch(API.GET_NOTULENSI.replace('$page', page + 1).replace('$published', published).replace('$general', general), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDocSharedWithMeNotulensi = async (page) => {
    try {
        const response = await fetch(API.GET_SHARED_NOTULENSI.replace('$page', page + 1), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token')
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const addDocNotulensi = async (data) => {
    try {
        const response = await fetch(API.ADD_DOCUMENT, {
            method: 'POST',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const editDocNotulensi = async (id, data) => {
    try {
        const response = await fetch(API.EDIT_DOCUMENT.replace('$id', id), {
            method: 'PUT',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const getDetailDocNotulensi = async (id) => {
    try {
        const response = await fetch(API.DETAIL_DOCUMENT.replace('$id', id), {
            method: 'GET',
            headers: {
                'Authorization': sessionStorage.getItem('token')
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}

export const deleteDocNotulensi = async (id) => {
    try {
        const response = await fetch(API.DELETE_DOCUMENT.replace('$id', id), {
            method: 'DELETE',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            }
        })
        return response.json()
    } catch (error) {
        return error
    }
}